;
export class History {
    constructor() {
        this._states = [new Map()];
        this._currentIndex = 0;
    }
    get hasUndo() { return this._currentIndex > 0; }
    get hasRedo() { return this._currentIndex < this._states.length - 1; }
    add(state) {
        const stateMap = this.getStateMap(state);
        if (stateMap.size === 0)
            return;
        if (this._currentIndex < this._states.length - 1) {
            this._states.splice(this._currentIndex + 1);
        }
        this.updateStates(stateMap);
        this._states.push(stateMap);
        this._currentIndex++;
    }
    clear() {
        this._states.length = 1;
        this._states[0].clear();
        this._currentIndex = 0;
    }
    undo() {
        if (!this.hasUndo)
            return;
        this._currentIndex--;
        this.restoreState(this._currentIndex);
    }
    redo() {
        if (!this.hasRedo)
            return;
        this._currentIndex++;
        this.restoreState(this._currentIndex);
    }
    getStateMap(state) {
        const map = new Map();
        let hasDifference = false;
        for (const entry of state) {
            const { target, props } = entry;
            if (target == null || props == null || Object.keys(props).length === 0)
                continue;
            const mappedProps = map.get(target) ?? {};
            for (const key in props) {
                const value = props[key];
                const targetValue = target[key];
                if (!(value?.equals?.(targetValue))) { // to fix sync we save all vec3 and euler (position, scale and rotation)
                    hasDifference = true;
                }
                if (value?.clone) {
                    mappedProps[key] = value.clone();
                }
                else {
                    mappedProps[key] = value;
                }
            }
            if (Object.keys(mappedProps).length > 0 && hasDifference) {
                map.set(target, mappedProps);
            }
        }
        return map;
    }
    updateStates(newState) {
        const currentStateMap = this._states[this._currentIndex];
        for (const [target, newProps] of newState) {
            if (!currentStateMap.has(target)) {
                currentStateMap.set(target, {});
            }
            const currentProps = currentStateMap.get(target);
            for (const key in newProps) {
                this.updateValue(newProps, currentProps, key); // update the current state using the newState values
                this.updateValue(target, newProps, key); // update the new state using the target values
            }
        }
    }
    restoreState(index) {
        const stateMap = this._states[index];
        const targetSet = new Set();
        for (const [target, props] of stateMap) {
            for (const key in props) {
                this.updateValue(props, target, key);
            }
            let targetToSet = target['parentEventHandler']?.['_object3D'] ?? target; // // for Vec3 and Euler, we need to notify the parent Object3D
            if (!targetToSet.isObject3D)
                continue;
            while (targetToSet !== null && !targetSet.has(targetToSet)) {
                targetSet.add(targetToSet);
                targetToSet = targetToSet.parent;
            }
        }
        for (const target of targetSet) {
            target.dispatchEvent?.({ type: 'historyChanged' });
        }
    }
    updateValue(src, dst, key) {
        const property = dst[key];
        const value = src[key];
        if (property?.copy && value) { // Vector2, Vector3, Quaternion, Euler have copy method
            property.copy(value);
            return;
        }
        if (property == null && value?.clone) {
            dst[key] = value.clone();
            return;
        }
        dst[key] = value;
    }
}
//# sourceMappingURL=History.js.map